
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import {AssetTypeProps} from "types/props-obj/AssetTypeProps";

const initialState: AssetTypeProps = {
    apiEndPoint: "asset-type",
    pageLimit: 5,
    pageNumber: 1,
    isOpen: false,
    list: [],
    item: null,
    error: null,
    alertPopup: false
};

const assetType = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all Item list
        getList(state, action) {
            state.list.push(action.payload);
            state.list = state.list.filter((liste) => liste.id !== 0);
        },
        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        },
        openToggle(state, action) {

            state.isOpen = action.payload.isOpen;
        },
        // get Item details
        setItem(state, action) {
            state.item = action.payload;
        },
        removeItem(state) {
            state.item =null;
        },

        // GET Items
        setItemsSuccess(state, action) {
            state.list = action.payload;
            // state.current_page=action.payload.current_page;
            // state.last_page=action.payload.last_page;
            // state.total=action.payload.total
        },

        // ADD Item
        addItemSuccess(state, action) {
            state.list = [...state.list,action.payload];
        },

        // EDIT Item
        editItemSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id === action.payload.id);
            state.item=action.payload;
            state.list[foundIndex] = action.payload;
        },

        deleteItemSuccess(state, action) {
            state.list = state.list.filter((item) => item.id !== action.payload);
        },



        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },


    }
});


export default assetType.reducer;

function getApiEndPoint(){
    return store.getState().assetType.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setPageLimit,setApiEndPoint,removeItem } = assetType.actions;
export function getList(params:any={}) {
    return async () => {
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(assetType.actions.setItemsSuccess(response.data));
        } catch (error) {
            dispatch(assetType.actions.hasError(error));
        }
    };
}

export function getItem(id: number | undefined) {
    return async () => {
        try {
            const response = await axios.get([getApiEndPoint(),  id].join('/'));
            dispatch(assetType.actions.setItem(response.data));
        } catch (error) {
            dispatch(assetType.actions.hasError(error));
        }
    };
}

export function addItem(ls:any) {
    return async () => {
        try {
            const response = await axios.post(getApiEndPoint(), ls,{headers:{'Content-Type': 'multipart/form-data'}});
            dispatch(assetType.actions.addItemSuccess(response.data));
        } catch (error) {
            dispatch(assetType.actions.hasError(error));
        }
    };
}

export function editItem(id: number | undefined,ls: any) {
    return async () => {
        try {
            const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
            dispatch(assetType.actions.editItemSuccess(response.data));
        } catch (error) {
            dispatch(assetType.actions.hasError(error));
        }
    };
}

export function deleteItem(id: number | undefined) {
    return async () => {
        try {
            await axios.delete([getApiEndPoint(),  id].join('/'));
            dispatch(assetType.actions.deleteItemSuccess(id));
        } catch (error) {
            dispatch(assetType.actions.hasError(error));
        }
    };
}